export default {

    CART_UPDATED: "cart_updated"
    
}